import React from 'react'
import '../../../../styles/donate-monthly/monthly.css'
import MonthlyTabContent from './TabContents/MonthlyTabContent'
import WeeklyTabContent from './TabContents/WeeklyTabContent'
import DailyTabContent from './TabContents/DailyTabContent'
import { Divider } from 'antd'
import IntlMessages from '../../../../util/IntlMessages'
import CalenderYearTabContent from './TabContents/CalenderYearTabContent'

const MonthlyTab = ({
	RadioGroup,
	RadioButton,
	selectedAmount,
	selectedSubscription,
	setSelectedSubscription,
	handleDonationTabChange,
	selectedMonthlyGateway
}) => {
	// const [selectedSubscription, setSelectedSubscription] = React.useState('monthly')
	// (initialAmount, amount, tabValue)
	return (
		<>
			{/* tab section */}
			<div className='tab-selector'>
				<div
					onClick={() =>
						handleDonationTabChange(
							selectedMonthlyGateway === 'bkash_recurring' ? 1 : 10,
							'DAILY'
						)
					}
					className={`tab-selector-button ${
						selectedSubscription === 'DAILY' ? 'active' : ''
					}`}
				>
					<IntlMessages id='donation.product.monthly.tab.3' />
				</div>
				<Divider
					style={{
						borderColor: '#D9D9D9',
						borderWidth: '1px',
						height: '25px',
						margin: 0
					}}
					type='vertical'
				/>
				{/* <div
					onClick={() => handleDonationTabChange(100, 'WEEKLY')}
					className={`tab-selector-button ${
						selectedSubscription === 'WEEKLY' ? 'active' : ''
					}`}
				>
					<IntlMessages id='donation.product.monthly.tab.2' />
				</div>
				<Divider
					style={{
						borderColor: '#D9D9D9',
						borderWidth: '1px',
						height: '25px',
						margin: 0
					}}
					type='vertical'
				/> */}
				<div
					onClick={() => handleDonationTabChange(300, 'THIRTY_DAYS')}
					className={`tab-selector-button ${
						selectedSubscription === 'THIRTY_DAYS' ? 'active' : ''
					}`}
				>
					<IntlMessages id='donation.product.monthly.tab.1' />
				</div>
				<Divider
					style={{
						borderColor: '#D9D9D9',
						borderWidth: '1px',
						height: '25px',
						margin: 0
					}}
					type='vertical'
				/>
				{/* <div
					onClick={() => handleDonationTabChange(6000, 'CALENDAR_YEAR')}
					className={`tab-selector-button ${
						selectedSubscription === 'CALENDAR_YEAR' ? 'active' : ''
					}`}
				>
					<IntlMessages id='donation.product.monthly.tab.4' />
				</div> */}
			</div>
			{/* <div className='tab-selector'>
				<div
					onClick={() => setSelectedSubscription('CALENDAR YEAR')}
					className={`tab-selector-button ${
						selectedSubscription === 'CALENDAR YEAR' ? 'active' : ''
					}`}
				>
					<IntlMessages id='donation.product.monthly.tab.4' />
				</div>
				<Divider
					style={{
						borderColor: '#D9D9D9',
						borderWidth: '1px',
						height: '25px',
						margin: 0
					}}
					type='vertical'
				/>
				<div
					onClick={() => setSelectedSubscription('THIRTY DAYS')}
					className={`tab-selector-button ${
						selectedSubscription === 'THIRTY DAYS' ? 'active' : ''
					}`}
				>
					<IntlMessages id='donation.product.monthly.tab.1' />
				</div>
				<Divider
					style={{
						borderColor: '#D9D9D9',
						borderWidth: '1px',
						height: '25px',
						margin: 0
					}}
					type='vertical'
				/>
				<div
					onClick={() => setSelectedSubscription('WEEKLY')}
					className={`tab-selector-button ${
						selectedSubscription === 'WEEKLY' ? 'active' : ''
					}`}
				>
					<IntlMessages id='donation.product.monthly.tab.2' />
				</div>
				<Divider
					style={{
						borderColor: '#D9D9D9',
						borderWidth: '1px',
						height: '25px',
						margin: 0
					}}
					type='vertical'
				/>
				<div
					onClick={() => setSelectedSubscription('DAILY')}
					className={`tab-selector-button ${
						selectedSubscription === 'DAILY' ? 'active' : ''
					}`}
				>
					<IntlMessages id='donation.product.monthly.tab.3' />
				</div>
			</div> */}

			{/* Tab Content */}
			{selectedSubscription === 'THIRTY_DAYS' && (
				<MonthlyTabContent
					RadioGroup={RadioGroup}
					RadioButton={RadioButton}
					selectedAmount={selectedAmount}
				/>
			)}
			{selectedSubscription === 'WEEKLY' && (
				<WeeklyTabContent
					RadioGroup={RadioGroup}
					RadioButton={RadioButton}
					selectedAmount={selectedAmount}
				/>
			)}
			{selectedSubscription === 'DAILY' && (
				<DailyTabContent
					RadioGroup={RadioGroup}
					RadioButton={RadioButton}
					selectedAmount={selectedAmount}
					selectedMonthlyGateway={selectedMonthlyGateway}
				/>
			)}
			{selectedSubscription === 'CALENDAR_YEAR' && (
				<CalenderYearTabContent
					RadioGroup={RadioGroup}
					RadioButton={RadioButton}
					selectedAmount={selectedAmount}
				/>
			)}
		</>
	)
}

export default MonthlyTab
